export enum QAQCType {
  None = 0,
  Milestone = 1,
  WorkOrder = 2,
  MilestoneWorkOrder = 3,
}
